module.exports = __webpack_public_path__ + "static/media/rando-equestre.4ea4bea9.webp";